export const LEGAL_DOCUMENTS = {
  consent: {
    url: "https://sozvuchno.ru/consent",
    label: "Согласие на обработку персональных данных",
    labelForForm: "cогласие на обработку персональных данных",
  },
  consentPublication: {
    url: "https://sozvuchno.ru/consent-publication",
    label: "Согласие на распространение персональных данных",
    labelForForm: " Согласен на распространение персональных данных",
  },
  policy: {
    url: "https://sozvuchno.ru/policy",
    label: "Политика обработки персональных данных",
    labelForForm: "политикой обработки персональных данных",
  },
  userAgreement: {
    url: "https://sozvuchno.ru/user-agreement",
    label: "Пользовательское соглашение",
    labelForCaption: "пользовательским соглашением",
  },
};
